// 유튜브 수익 창출(YPP) 확인 상태 — 화면 공용 판정 (2026-10-03 대표 결정 「본인 선택으로 받고, 3일 동안 수익이 수집되지 않으면 미승인으로 간주」)
//
// 상태 넷:
//   verified  is_ypp 이고 대기 표시 없음 — 수익 기록이 잡혔거나 운영팀이 확인했다
//   pending   is_ypp 이고 ypp_pending_since 있음 — 등록할 때 본인이 「승인」을 고른 값. 아직 아무도 확인하지 않았다
//   reported  is_ypp 아님 · ypp_self_reported_at 있음 — 본인이 알렸고 운영팀 확인을 기다린다(대기 만료 뒤에도 여기로 온다)
//   none      미승인
//
// 판정·전환은 전부 서버가 한다(마이그레이션 20261017180000):
//   - 등록할 때 회원이 is_ypp=true 로 넣으면 트리거 tg_channel_ypp_pending 이 ypp_pending_since·ypp_self_reported_at 을 채운다.
//   - 크론 channel_ypp_pending_sweep(매일 03:25 KST): 수익 기록(스튜디오 수집 · 구글 연결 지표)이 보이면 대기를 푼다(=확인됨).
//     대기 N일이 지나도 없으면 is_ypp=false 로 돌리고 알림 1건 — ypp_self_reported_at 은 남아 어드민에 「YPP 확인 요청」으로 보인다.
//   - 수익이 나중에 잡히면 기존 크론 refresh_channel_ypp_from_revenue 가 다시 승인으로 올린다.
//
// 🔒 YPP_PENDING_DAYS 는 서버 app_config 'channel_ypp_pending'.days(기본 3 · channel_ypp_pending_days())와 같아야 한다.
//    화면 문구에만 쓴다 — 서버 값을 바꾸면 이 숫자와 가이드 문구도 같이 바꾼다.

export const YPP_PENDING_DAYS = 3;

export const YPP_STATE = Object.freeze({
  VERIFIED: "verified",
  PENDING: "pending",
  REPORTED: "reported",
  NONE: "none",
});

/** 채널 행 → YPP 확인 상태 */
export function yppState(channel) {
  const c = channel || {};
  if (c.is_ypp) return c.ypp_pending_since ? YPP_STATE.PENDING : YPP_STATE.VERIFIED;
  return c.ypp_self_reported_at ? YPP_STATE.REPORTED : YPP_STATE.NONE;
}

/** 대기가 끝나는 시각(ISO). 대기 중이 아니거나 시각을 못 읽으면 null */
export function yppPendingDeadline(channel, days = YPP_PENDING_DAYS) {
  if (yppState(channel) !== YPP_STATE.PENDING) return null;
  const since = new Date(channel.ypp_pending_since).getTime();
  if (!Number.isFinite(since)) return null;
  return new Date(since + days * 24 * 60 * 60 * 1000).toISOString();
}

/** 어드민 화면 라벨(운영팀 화면은 한국어 고정) */
export function yppAdminLabel(channel) {
  switch (yppState(channel)) {
    case YPP_STATE.VERIFIED:
      return "YPP 승인";
    case YPP_STATE.PENDING:
      return "YPP 본인 선택 · 확인 전";
    case YPP_STATE.REPORTED:
      return "YPP 확인 요청";
    default:
      return "YPP 미승인";
  }
}

/** 어드민 배지·칩 설명(title) — 대기·확인 요청일 때만 */
export function yppAdminHint(channel, days = YPP_PENDING_DAYS) {
  const state = yppState(channel);
  if (state === YPP_STATE.PENDING) {
    const deadline = yppPendingDeadline(channel, days);
    const until = deadline ? ` (${deadline.slice(0, 10)} 무렵)` : "";
    return `크리에이터가 등록할 때 「승인」을 고른 값이에요 — 아직 확인 전. 수익 기록이 잡히면 자동으로 확인되고, ${days}일 안에 없으면${until} 「미승인」으로 바뀌어요. 스튜디오에서 확인했다면 채널 수정에서 「확인했어요」를 체크해 주세요`;
  }
  if (state === YPP_STATE.REPORTED) {
    return `크리에이터가 ${String(channel.ypp_self_reported_at).slice(0, 10)} 에 YPP 승인을 알림 — 채널 수정에서 확인 후 켜 주세요`;
  }
  return "";
}
